import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

/**
 * LanguageToggle — Phase 6a.6 per spec §9.2.
 *
 * Toggles between Turkish (tr) and English (en). Choice is persisted by
 * i18next's LanguageDetector in localStorage["ifrs16:lang"] so the next
 * page load honours the user's last selection.
 */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language.startsWith("tr") ? "tr" : "en";

  const handleToggle = () => {
    void i18n.changeLanguage(currentLang === "tr" ? "en" : "tr");
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleToggle}
      className="gap-1.5"
      aria-label={t("language.toggle")}
    >
      <Languages size={16} />
      <span className="text-xs uppercase font-medium">{currentLang}</span>
    </Button>
  );
}
